import { useMutation } from '@tanstack/react-query';
import { AuthApiError } from '@supabase/supabase-js';

import { supabaseClient } from 'src/auth/supabase';

export const useRequestOtpSupabase = () =>
    useMutation<unknown, AuthApiError, { email: string }>({
        mutationKey: ['auth', 'otp', 'request'],
        mutationFn: async ({ email }) => {
            const res = await supabaseClient.auth.signInWithOtp({
                email,
                options: {
                    emailRedirectTo: window.location.origin,
                    shouldCreateUser: false,
                },
            });

            if (res.error) throw res.error;

            return res.data;
        },
    });
